import { createGlobalStyle } from "styled-components";
export const GlobalStyle = createGlobalStyle`
  * {
    border: 0;
    padding: 0;
    margin: 0;
    font-family: 'Oswald', sans-serif;
  }

  body{
    background-color:  #F2E9e6;
  }
`;
